<!-- Modal: Keep Spot Authorization -->
<div class="modal fade" id="modal_keep_spot" tabindex="-1" role="dialog" aria-labelledby="modalKeepSpotLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalKeepSpotLabel">Authorization Required</h5>
                <button type="button" class="btn-icon" data-dismiss="modal" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    <strong>{{ modal_emp?.name ?? modal_emp?.email }}</strong> was with a guest. You are attempting to give them back
                    their place in line. This action requires an admin password.
                </p>

                <form>
                    <div class="form-group">
                        <label class="form-label" for="adminCode">Admin Code</label>
                        <input #adminCode type="password" class="form-control" id="adminCode" placeholder="Enter admin code">
                    </div>
                    <div *ngIf="modal_error" class="alert alert-danger" role="alert">
                        <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                        {{ modal_error }}
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="modal_error=undefined;">Cancel</button>
                <button type="button" class="btn btn-primary"
                    (click)="authorizeKeepPlaceInLine(modal_emp, adminCode.value); adminCode.value=''">Authorize</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Reorder Authorization -->
<div class="modal fade" id="modal_drag_reorder" tabindex="-1" role="dialog" aria-labelledby="modalReorderLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalReorderLabel">Authorization Required</h5>
                <button type="button" class="btn-icon" data-dismiss="modal" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    You are attempting to manually change the board order.
                    This action requires an admin password.
                </p>

                <form>
                    <div class="form-group">
                        <label class="form-label" for="adminCodeReorder">Admin Code</label>
                        <input #adminCodeReorder type="password" class="form-control" id="adminCodeReorder"
                            placeholder="Enter admin code">
                    </div>
                    <div *ngIf="modal_error" class="alert alert-danger" role="alert">
                        <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                        {{ modal_error }}
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="cancelReorder()">Cancel</button>
                <button type="button" class="btn btn-primary"
                    (click)="authorizeReorder(adminCodeReorder.value); adminCodeReorder.value=''">Authorize</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Remove Employee -->
<div class="modal fade" id="modal_remove_emp" tabindex="-1" role="dialog" aria-labelledby="modalRemoveLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalRemoveLabel">Remove Employee From Board</h5>
                <button type="button" class="btn-icon" data-dismiss="modal" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    You are attempting to remove <strong>{{ nextInactiveEmployee?.name || nextInactiveEmployee?.email }}</strong> from
                    the board for the day.
                </p>
                <p class="text-muted">Are you sure you want to do this?</p>
                <div *ngIf="modal_error" class="alert alert-danger" role="alert">
                    <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                    {{ modal_error }}
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal"
                    (click)="authorizeMakeInactive(nextInactiveEmployee)">Remove From Board</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Keep Spot Authorization -->
<div class="modal fade" id="modal_keep_spot" tabindex="-1" role="dialog" aria-labelledby="modalKeepSpotLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalKeepSpotLabel">Authorization Required</h5>
                <button type="button" class="btn-icon" data-dismiss="modal" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    <strong>{{ modal_emp?.name ?? modal_emp?.email }}</strong> was with a guest. You are attempting to give them back
                    their place in line. This action requires an admin password.
                </p>

                <form>
                    <div class="form-group">
                        <label class="form-label" for="adminCode">Admin Code</label>
                        <input #adminCode type="password" class="form-control" id="adminCode" placeholder="Enter admin code">
                    </div>
                    <div *ngIf="modal_error" class="alert alert-danger" role="alert">
                        <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                        {{ modal_error }}
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="modal_error=undefined;">Cancel</button>
                <button type="button" class="btn btn-primary"
                    (click)="authorizeKeepPlaceInLine(modal_emp, adminCode.value); adminCode.value=''">Authorize</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Reorder Authorization -->
<div class="modal fade" id="modal_drag_reorder" tabindex="-1" role="dialog" aria-labelledby="modalReorderLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalReorderLabel">Authorization Required</h5>
                <button type="button" class="btn-icon" data-dismiss="modal" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    You are attempting to manually change the board order.
                    This action requires an admin password.
                </p>

                <form>
                    <div class="form-group">
                        <label class="form-label" for="adminCodeReorder">Admin Code</label>
                        <input #adminCodeReorder type="password" class="form-control" id="adminCodeReorder"
                            placeholder="Enter admin code">
                    </div>
                    <div *ngIf="modal_error" class="alert alert-danger" role="alert">
                        <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                        {{ modal_error }}
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="cancelReorder()">Cancel</button>
                <button type="button" class="btn btn-primary"
                    (click)="authorizeReorder(adminCodeReorder.value); adminCodeReorder.value=''">Authorize</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Remove Employee -->
<div class="modal fade" id="modal_remove_emp" tabindex="-1" role="dialog" aria-labelledby="modalRemoveLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalRemoveLabel">Remove Employee From Board</h5>
                <button type="button" class="btn-icon" data-dismiss="modal" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    You are attempting to remove <strong>{{ nextInactiveEmployee?.name || nextInactiveEmployee?.email }}</strong> from
                    the board for the day.
                </p>
                <p class="text-muted">Are you sure you want to do this?</p>
                <div *ngIf="modal_error" class="alert alert-danger" role="alert">
                    <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                    {{ modal_error }}
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal"
                    (click)="authorizeMakeInactive(nextInactiveEmployee)">Remove From Board</button>
            </div>
        </div>
    </div>
</div>

<!-- Main Board Container -->
<div class="board-container" (click)="closeContextMenu()">
    <!-- Board Header -->
    <div class="board-header">
        <h1 class="board-title">
            <fa-icon [icon]="icons.faClipboardList"></fa-icon>
            Board Management
        </h1>
        <p class="board-subtitle">Manage employee rotations, breaks, and assignments</p>
    </div>

    <!-- LEGACY LAYOUT: Single-channel table (when isLegacyMode = true) -->
    <div *ngIf="isLegacyMode" class="legacy-layout">
        <h3 class="m-3 text-center">Manage Board</h3>
        <table class="table table-striped table-bordered" cdkDropList [cdkDropListData]="legacyActiveEmployees" (cdkDropListDropped)="dropLegacy($event)">
            <thead>
                <tr>
                    <th style="width: 30px;" *ngIf="editMode">+/-</th>
                    <th style="width: 20%;" class="text-center"><b>Available</b></th>
                    <th style="width: 20%;" class="text-center"><b>With Guest</b></th>
                    <th style="width: 20%;" class="text-center"><b>Appointment</b></th>
                    <th style="width: 20%;" class="text-center" *ngIf="showDelivery"><b>Delivery</b></th>
                    <th style="width: 20%;" class="text-center"><b>Break</b></th>
                    <th style="width: 30px;" *ngIf="editMode"></th>
                </tr>
            </thead>
            <tbody>
                <!-- Active employees row-per-employee -->
                <tr *ngFor="let emp of legacyActiveEmployees" cdkDrag [cdkDragData]="emp" [cdkDragDisabled]="!editMode">
                    <!-- +/- Remove button column (edit mode only) -->
                    <td *ngIf="editMode">
                        <button type="button" class="btn btn-secondary" (click)="makeInactive(normalizedToEmployee(emp))" 
                                title="Remove From Rotation" data-toggle="modal" data-target="#modal_remove_emp">
                            <fa-icon [icon]="icons.faMinus"></fa-icon>
                        </button>
                    </td>
                    
                    <!-- Available column (state = 'available') -->
                    <td class="col-available">
                        <div *ngIf="getLegacyState(emp) == 'available'">
                            <app-up-board-employee [editMode]="true" [emp]="normalizedToEmployee(emp)" 
                                [up]="emp === legacyUp" [onDeck]="emp === legacyOnDeck">
                            </app-up-board-employee>
                        </div>
                        <div class="btn-group" role="group" *ngIf="getLegacyState(emp) != 'available'">
                            <!-- Return to queue buttons (from with_guest or other states) -->
                            <button *ngIf="editMode && (getLegacyState(emp) == 'with_guest' || getLegacyState(emp) == 'with_guest_delivery')"
                                (click)="enterQueue(normalizedToEmployee(emp), true)" type="button" class="btn btn-secondary" title="Send To Bottom">
                                <fa-icon [icon]="icons.faArrowDown"></fa-icon>
                            </button>
                            <button *ngIf="editMode && getLegacyState(emp) != 'available' && (getLegacyState(emp) != 'with_guest' && getLegacyState(emp) != 'with_guest_delivery')"
                                type="button" (click)="enterQueue(normalizedToEmployee(emp), false)" class="btn btn-secondary" title="Keep Place In Line">
                                <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
                            </button>
                            <button *ngIf="editMode && (getLegacyState(emp) == 'with_guest' || getLegacyState(emp) == 'with_guest_delivery')"
                                type="button" (click)="modal_emp = normalizedToEmployee(emp)" class="btn btn-danger" title="Keep Place In Line"
                                data-toggle="modal" data-target="#modal_keep_spot">
                                <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
                            </button>
                        </div>
                    </td>
                    
                    <!-- With Guest column (state = 'with_guest') -->
                    <td class="col-with-guest">
                        <div *ngIf="getLegacyState(emp) == 'with_guest'">
                            <app-up-board-employee [editMode]="true" [emp]="normalizedToEmployee(emp)"></app-up-board-employee>
                        </div>
                        <button *ngIf="editMode && getLegacyState(emp) == 'available'" (click)="sendWithGuest(normalizedToEmployee(emp))" type="button" 
                                title="Send With Guest"
                                [ngClass]="{'btn': true, 'btn-success': emp === legacyUp, 'btn-warning': emp === legacyOnDeck, 
                                           'btn-secondary': emp !== legacyUp && emp !== legacyOnDeck}">
                            <fa-icon [icon]="icons.faUser"></fa-icon>
                        </button>
                    </td>
                    
                    <!-- Appointment column (state = 'with_apt') -->
                    <td class="col-with-apt">
                        <div *ngIf="getLegacyState(emp) == 'with_apt'">
                            <app-up-board-employee [editMode]="true" [emp]="normalizedToEmployee(emp)"></app-up-board-employee>
                        </div>
                        <button type="button" class="btn btn-secondary" *ngIf="editMode && getLegacyState(emp) == 'available'"
                                (click)="sendOnApt(normalizedToEmployee(emp))" title="Send On Appointment">
                            <fa-icon [icon]="icons.faCalendar"></fa-icon>
                        </button>
                    </td>
                    
                    <!-- Delivery column (state = 'with_guest_delivery' or 'with_apt_delivery') -->
                    <td class="col-delivery" *ngIf="showDelivery">
                        <div *ngIf="getLegacyState(emp) == 'with_guest_delivery' || getLegacyState(emp) == 'with_apt_delivery'">
                            <app-up-board-employee [editMode]="true" [emp]="normalizedToEmployee(emp)"></app-up-board-employee>
                        </div>
                        <button *ngIf="editMode && (getLegacyState(emp) == 'with_guest' || getLegacyState(emp) == 'with_apt')"
                                (click)="sendOnDelivery(normalizedToEmployee(emp))" type="button" class="btn btn-secondary" title="Send On Delivery">
                            <fa-icon [icon]="icons.faTruck"></fa-icon>
                        </button>
                    </td>
                    
                    <!-- Break column (state = 'break') -->
                    <td class="col-break">
                        <div *ngIf="getLegacyState(emp) == 'break'">
                            <app-up-board-employee [editMode]="true" [emp]="normalizedToEmployee(emp)"></app-up-board-employee>
                        </div>
                        <button *ngIf="editMode && getLegacyState(emp) == 'available'" (click)="goOnBreak(normalizedToEmployee(emp))" type="button"
                                class="btn btn-secondary" title="Go On Break">
                            <fa-icon [icon]="icons.faHamburger"></fa-icon>
                        </button>
                    </td>
                    
                    <!-- Drag handle column (edit mode only) -->
                    <td *ngIf="editMode">
                        <div cdkDragHandle style="cursor: pointer;">
                            <fa-icon [icon]="icons.faBars"></fa-icon>
                        </div>
                    </td>
                </tr>
                
                <!-- Inactive employees rows (edit mode only) -->
                <tr *ngFor="let emp of legacyInactiveEmployees" style="background-color: #afafafa0;">
                    <td *ngIf="editMode">
                        <button type="button" class="btn btn-secondary" (click)="makeEmployeeActive(emp)" title="Add To Rotation">
                            <fa-icon [icon]="icons.faPlus"></fa-icon>
                        </button>
                    </td>
                    <td *ngIf="editMode" class="text-muted">{{ emp.name }}</td>
                    <td *ngIf="editMode"></td>
                    <td *ngIf="editMode"></td>
                    <td *ngIf="editMode && showDelivery"></td>
                    <td *ngIf="editMode"></td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- MODERN LAYOUT: Multi-Column Card-Based UI (when !isLegacyMode) -->
    <ng-container *ngIf="!isLegacyMode">
    <!-- Multi-Column Layout: All Enabled Channels Shown Simultaneously -->
    <div class="board-multi-column-wrapper">
        <div class="row">
             <!-- Floor Ups Column (Instore) - Always visible if instore enabled -->
             <div class="col-channel" *ngIf="enabledChannels.includes('instore')">
                 <div class="channel-header">
                     <h5 class="channel-title">Available for Walk-ins</h5>
                     <span class="channel-count">{{ floorUpsEmployees.length }}</span>
                 </div>
                 <div 
                     cdkDropList
                     [cdkDropListData]="floorUpsEmployees"
                     (cdkDropListDropped)="drop($event, 'instore')"
                     cdkDropListSortingDisabled="false"
                     class="employee-list drop-zone">
                       <div *ngFor="let emp of floorUpsEmployees; trackBy: trackByEmail" 
                           cdkDrag 
                           [cdkDragData]="emp"
                           [cdkDragDisabled]="!editMode"
                           class="employee-card"
                           [ngClass]="getAnimationClass(emp.email)"
                           (contextmenu)="onEmployeeContextMenu($event, emp, 'instore')">
                           <div *cdkDragPreview class="drag-preview bg-info">
                               <app-up-board-employee [editMode]="true" [emp]="normalizedToEmployee(emp)" [normalized]="emp" [channel]="'instore'" [showDelivery]="showDelivery" [unavailable]="shouldApplyFullUnavailability(emp, 'instore') || shouldApplySizeOnlyUnavailability(emp, 'instore')"></app-up-board-employee>
                           </div>
                             <div class="card-content" (click)="onEmployeeClick(emp, 'instore')">
                                 <app-up-board-employee 
                                     [editMode]="editMode"
                                     [emp]="normalizedToEmployee(emp)"
                                     [normalized]="emp"
                                     [channel]="'instore'"
                                     [showDelivery]="showDelivery"
                                     [up]="emp.email === upInstore?.email"
                                     [onDeck]="emp.email === onDeckInstore?.email"
                                     [unavailable]="shouldApplyFullUnavailability(emp, 'instore') || shouldApplySizeOnlyUnavailability(emp, 'instore')">
                                 </app-up-board-employee>
                             </div>
                           <div *ngIf="editMode" cdkDragHandle class="drag-handle" title="Drag to reorder">
                               <fa-icon [icon]="icons.faGripVertical"></fa-icon>
                           </div>
                       </div>
                     <div *ngIf="floorUpsEmployees.length === 0" class="empty-state">
                         <p class="text-muted">No employees</p>
                     </div>
                 </div>
                 
               </div>
            
             <!-- With Guest Column (Instore) - Always visible if instore enabled -->
             <div class="col-channel" *ngIf="enabledChannels.includes('instore')">
                 <div class="channel-header">
                     <h5 class="channel-title">With Guest</h5>
                     <span class="channel-count">{{ withGuestEmployees.length }}</span>
                 </div>
                  <div class="employee-list drop-zone">
                       <div *ngFor="let emp of withGuestEmployees; trackBy: trackByEmail" 
                           class="employee-card"
                           [ngClass]="getAnimationClass(emp.email)"
                           (contextmenu)="onEmployeeContextMenu($event, emp, 'with_guest')">
                            <div class="card-content" (click)="onEmployeeClick(emp, 'with_guest')">
                                <app-up-board-employee 
                                    [editMode]="editMode"
                                    [emp]="normalizedToEmployee(emp)"
                                    [normalized]="emp"
                                    [channel]="'instore'"
                                    [showDelivery]="showDelivery"
                                    [up]="emp.email === upInstore?.email"
                                    [onDeck]="emp.email === onDeckInstore?.email"
                                    [unavailable]="false">
                                </app-up-board-employee>
                            </div>
                       </div>
                      <div *ngIf="withGuestEmployees.length === 0" class="empty-state">
                          <p class="text-muted">No employees</p>
                      </div>
                  </div>
             </div>
            
             <!-- Phone Ups Column - Visible if phone channel enabled -->
             <div class="col-channel" *ngIf="enabledChannels.includes('phone')">
                 <div class="channel-header">
                     <h5 class="channel-title">Phone</h5>
                     <span class="channel-count">{{ phoneUpsEmployees.length }}</span>
                 </div>
                 <div 
                     cdkDropList
                     [cdkDropListData]="phoneUpsEmployees"
                     (cdkDropListDropped)="drop($event, 'phone')"
                     cdkDropListSortingDisabled="false"
                     class="employee-list drop-zone">
                       <div *ngFor="let emp of phoneUpsEmployees; trackBy: trackByEmail" 
                           cdkDrag 
                           [cdkDragData]="emp"
                           [cdkDragDisabled]="!editMode"
                           class="employee-card"
                           [ngClass]="[getAnimationClass(emp.email), isEmployeeUnavailable(emp, 'phone') ? 'unavailable' : '']"
                           (contextmenu)="onEmployeeContextMenu($event, emp, 'phone')">
                           <div *cdkDragPreview class="drag-preview bg-info">
                               <app-up-board-employee [editMode]="true" [emp]="normalizedToEmployee(emp)" [normalized]="emp" [channel]="'phone'" [showDelivery]="showDelivery" [unavailable]="shouldApplyFullUnavailability(emp, 'phone')"></app-up-board-employee>
                           </div>
                             <div class="card-content" (click)="onEmployeeClick(emp, 'phone')">
                                 <app-up-board-employee 
                                     [editMode]="editMode"
                                     [emp]="normalizedToEmployee(emp)"
                                     [normalized]="emp"
                                     [channel]="'phone'"
                                     [showDelivery]="showDelivery"
                                    [up]="emp.email === upPhone?.email"
                                    [onDeck]="emp.email === onDeckPhone?.email"
                                    [unavailable]="shouldApplyFullUnavailability(emp, 'phone')"
                                      [isUpInInstore]="emp.email === upInstore?.email"
                                      [isOnDeckInInstore]="emp.email === onDeckInstore?.email">
                                 </app-up-board-employee>
                             </div>
                           <div *ngIf="editMode" cdkDragHandle class="drag-handle" title="Drag to reorder">
                               <fa-icon [icon]="icons.faGripVertical"></fa-icon>
                           </div>
                       </div>
                     <div *ngIf="phoneUpsEmployees.length === 0" class="empty-state">
                         <p class="text-muted">No employees</p>
                     </div>
                 </div>
             </div>
            
             <!-- Internet Ups Column - Visible if online channel enabled -->
             <div class="col-channel" *ngIf="enabledChannels.includes('online')">
                 <div class="channel-header">
                     <h5 class="channel-title">Internet</h5>
                     <span class="channel-count">{{ internetUpsEmployees.length }}</span>
                 </div>
                 <div 
                     cdkDropList
                     [cdkDropListData]="internetUpsEmployees"
                     (cdkDropListDropped)="drop($event, 'online')"
                     cdkDropListSortingDisabled="false"
                     class="employee-list drop-zone">
                       <div *ngFor="let emp of internetUpsEmployees; trackBy: trackByEmail" 
                           cdkDrag 
                           [cdkDragData]="emp"
                           [cdkDragDisabled]="!editMode"
                           class="employee-card"
                           [ngClass]="[getAnimationClass(emp.email), isEmployeeUnavailable(emp, 'online') ? 'unavailable' : '']"
                           (contextmenu)="onEmployeeContextMenu($event, emp, 'online')">
                          <div *cdkDragPreview class="drag-preview bg-info">
                              <app-up-board-employee [editMode]="true" [emp]="normalizedToEmployee(emp)" [normalized]="emp" [channel]="'online'" [showDelivery]="showDelivery" [unavailable]="shouldApplyFullUnavailability(emp, 'online')"></app-up-board-employee>
                          </div>
                            <div class="card-content" (click)="onEmployeeClick(emp, 'online')">
                                <app-up-board-employee 
                                    [editMode]="editMode"
                                    [emp]="normalizedToEmployee(emp)"
                                    [normalized]="emp"
                                    [channel]="'online'"
                                    [showDelivery]="showDelivery"
                                    [up]="emp.email === upOnline?.email"
                                    [onDeck]="emp.email === onDeckOnline?.email"
                                    [unavailable]="shouldApplyFullUnavailability(emp, 'online')"
                                    [isUpInInstore]="emp.email === upInstore?.email"
                                    [isOnDeckInInstore]="emp.email === onDeckInstore?.email">
                                </app-up-board-employee>
                            </div>
                          <div *ngIf="editMode" cdkDragHandle class="drag-handle" title="Drag to reorder">
                              <fa-icon [icon]="icons.faGripVertical"></fa-icon>
                          </div>
                      </div>
                     <div *ngIf="internetUpsEmployees.length === 0" class="empty-state">
                         <p class="text-muted">No employees</p>
                     </div>
                 </div>
             </div>
        </div>
    </div>
    
    <!-- Story 3.5.6: Inactive Employees Section (Redesigned - Footer-like, Outside Multi-Column Wrapper) -->
    <div class="inactive-section-container" *ngIf="inactiveEmployees.length > 0">
        <div class="inactive-section">
            <h3 class="inactive-section-title">
                <fa-icon [icon]="icons.faUserSlash"></fa-icon>
                Inactive Employees
                <span class="channel-count inactive-pill">{{ inactiveEmployees.length }}</span>
            </h3>
            
            <div class="inactive-employees-grid">
                <app-up-board-employee 
                    *ngFor="let emp of inactiveEmployees; trackBy: trackByEmail"
                    [editMode]="false"
                    [emp]="normalizedToEmployee(emp)"
                    [normalized]="emp"
                    [channel]="'instore'"
                    [showDelivery]="false"
                    [up]="false"
                    [onDeck]="false"
                    [unavailable]="false"
                    [isInactive]="true"
                    (activate)="makeEmployeeActive(emp)"
                    (click)="onEmployeeClick(emp, 'instore')"
                    tabindex="0"
                    (keydown.enter)="makeEmployeeActive(emp)"
                    (keydown.space)="makeEmployeeActive(emp); $event.preventDefault()">
                </app-up-board-employee>
            </div>
        </div>
    </div>
</ng-container>

<!-- Employee Action Modal (Story 3.5) -->
<app-employee-action-modal
    [employee]="selectedEmployee"
    [column]="selectedColumn"
    [boardConfig]="boardConfig"
    [upEmployeeEmail]="upInstore?.email || null"
    [onDeckEmployeeEmail]="onDeckInstore?.email || null"
    [isVisible]="showActionModal"
    (actionSelected)="executeAction($event)"
    (closed)="closeActionModal()">
</app-employee-action-modal>